//Imports
import React from "react";
import Select, { components } from 'react-select';
import DatePicker from "react-datepicker";
//Imports data
import staticData from '../../../contexts/staticData.json';
//Imports Icons
import downArrow from '../../../assets/icons/downArrow.svg';
import establishmentLogo from '../../../assets/icons/establishmentLogo.svg';
import calendar from '../../../assets/icons/calendar.svg';

function FormEditProject({
    nameProject, setNameProject,
    selectRegionProject, setSelectRegionProject,
    selectCommuneProject, setSelectCommuneProject,
    selectDependencies, setSelectDependencies,
    dateFrom, setDateFrom,
    dateUntil, setDateUntil,
    disabled
}) {

    // Function to handle changes in project-level Select components
    const handleProjectSelectChange = (selectedOption, { name }) => {
        if (name === 'regionProject') {
            setSelectRegionProject(selectedOption.value);
            setSelectCommuneProject(''); // Clear commune if region changes
        } else if (name === 'communeProject') {
            setSelectCommuneProject(selectedOption.value);
        } else if (name === 'dependencies') {
            setSelectDependencies(selectedOption.value);
        }
    };

    const handleProjectInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'nameProject') {
            setNameProject(value);
        }
    };

    const handleDateFromChange = (date) => {
        setDateFrom(date);
        
        // Si la fecha "Hasta" es anterior a la nueva fecha "Desde", la reseteamos
        if (dateUntil && date && dateUntil < date) {
            setDateUntil(null);
        }
    };

    const sortedRegions = [...staticData.regiones].sort((a, b) =>
        a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
    );
    const sortedDependencies = [...staticData.dependencies].sort((a, b) =>
        a.localeCompare(b, 'es', { sensitivity: 'base' })
    );
    const regionData = staticData.regiones.find((region) => region.name === selectRegionProject);
    const sortedCommunes = regionData ?
        [...regionData.communes].sort((a, b) =>
            a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        ) :
        [];
    return (
        <>
            <article className='first-box flex'>
                <div className='flex'>
                    <span className='input-box'>
                        <label htmlFor='nameProject' className='label'>Nombre Sostenedor (*)</label>
                        <input
                            type='text'
                            id='nameProject'
                            name='nameProject'
                            className='input'
                            placeholder='Ingrese nombre sostenedor'
                            value={nameProject}
                            onChange={handleProjectInputChange}
                            disabled={disabled}
                        />
                    </span>
                    <span className='input-select flex'>
                        <label htmlFor='regionProject' className='label-region'>Región (*)</label>
                        <Select
                            name='regionProject'
                            id='regionProject'
                            options={sortedRegions.map((region) => ({
                                value: region.name,
                                label: region.name
                            }))}
                            onChange={handleProjectSelectChange}
                            value={selectRegionProject}
                            placeholder={selectRegionProject ? selectRegionProject : 'Selecciona una opción'}
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            isDisabled={disabled}
                        />
                    </span>
                    <span className='input-select flex'>
                        <label htmlFor='communeProject' className='label-region'>Comuna (*)</label>
                        <Select
                            name='communeProject'
                            id='communeProject'
                            options={sortedCommunes.map((commune) => ({
                                value: commune.name,
                                label: commune.name
                            }))}
                            onChange={handleProjectSelectChange}
                            value={selectCommuneProject}
                            placeholder={selectCommuneProject ? selectCommuneProject : 'Selecciona una opción'}
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            isDisabled={disabled}
                        />
                    </span>
                    <span className='input-select flex'>
                        <label htmlFor='dependencies' className='label-region'>Dependencia (*)</label>
                        <Select
                            name='dependencies'
                            id='dependencies'
                            options={sortedDependencies.map((dependencie) => ({
                                value: dependencie,
                                label: dependencie
                            }))}
                            onChange={handleProjectSelectChange}
                            value={selectDependencies}
                            placeholder={selectDependencies ? selectDependencies : 'Selecciona una opción'}
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            isDisabled={disabled}
                        />
                    </span>
                </div>
                <aside className='box-logo flex'>
                    <img src={establishmentLogo} className='icon' alt='Logo de establecimiento' />
                </aside>
            </article>
            <article className='second-box flex'>
                <p>Válidez del Contrato (*)</p>
                <aside className='box-date flex'>
                    <span className='input-select flex'>
                        <label htmlFor='dateFrom' className='label-region'>Desde</label>
                        <DatePicker
                            selected={dateFrom}
                            onChange={handleDateFromChange}
                            className='custom-date-input'
                            dateFormat='dd-MM-yyyy'
                            placeholderText='Selecciona una fecha'
                            disabled={disabled}
                        />
                        <img src={calendar} className='icon' alt='Icono calendario' />
                    </span>
                    <span className='input-select flex'>
                        <label htmlFor='dateUntil' className='label-region'>Hasta</label>
                        <DatePicker
                            selected={dateUntil}
                            onChange={(date) => setDateUntil(date)}
                            minDate={dateFrom}
                            className='custom-date-input'
                            dateFormat='dd-MM-yyyy'
                            placeholderText='Selecciona una fecha'
                            disabled={disabled || !dateFrom}
                        />
                        <img src={calendar} className='icon' alt='Icono calendario' />
                    </span>
                </aside>
            </article>
        </>
    )
}

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default FormEditProject;